import styled from 'styled-components';
import Button from 'form/button';
import {Link} from 'react-router-dom';

export const ButtonDefault = styled(Button)`
  display: inline-block;
  padding: 14px 20px;
  max-width: 300px;
  background-image: linear-gradient(to bottom, #fec44c, #e69b01);
  border-radius: 4px;
  color: #fff;
  font-size: 18px;
  border-width: 0;
  cursor: pointer;
  transition: all .3s linear;
  outline: 0;
  margin-right: 10px;

  &:disabled {
    background-color: #efddb6;
    cursor: not-allowed;
  }
  &:hover {
    color: #fff;
  }
  @media (max-width: 600px){
    min-width: 250px;
    text-align: center;
      margin-top: 10px;
      margin-right: 0;
  }
  @media (max-width: 320px){
    min-width: 60%;
  }

  &:hover {
    background-image: linear-gradient(rgba(216, 216, 216, 0.5), rgba(216, 216, 216, 0.5)), linear-gradient(#fec44c, #fec44c);
    background-blend-mode: multiply, normal;
  }
`;

export const ButtonRegistrationLogin = ButtonDefault.extend`
    align-self: center;
`;

export const ButtonWrap = styled.div`
  margin-top: 35px;
  display: flex;
  justify-content: space-around;
  @media (max-width: 600px){
    flex-direction: column;
    align-items: center;
  }
`;


export const ButtonDanger = ButtonDefault.extend`
  background-color: #dd4b39;
  background-image: none;

  &:hover {
    background-color: #d73925;
    background-image: none;
  }
`;
export const ButtonDangerModal = ButtonDanger.extend`
  @media (max-width: 600px){
    min-width: 200px;
  }
`;

export const ButtonDangerDelete = ButtonDanger.extend`
`;

export const ButtonPrimary = ButtonDefault.extend`
  background-color: #367fa9;
  background-image: none;

  &:hover {
    background-color: #204d74;
    background-image: none;
  }
`;

export const ButtonSuccess = ButtonDefault.extend`
  background-color: #008d4c;
  background-image: none;

  &:hover {
    background-color: #398439;
    background-image: none;
  }
`;

export const ButtonSuccessModal = ButtonSuccess.extend`
  @media (max-width: 600px){
    min-width: 200px;
}
`

export const ButtonInfo = ButtonDefault.extend`
  background-color: #00acd6;
  background-image: none;
  text-align: center;

  &:hover {
    background-color: #269abc;
    background-image: none;
  }
`;

export const SmallButton = ButtonDefault.extend`
  padding: 7px 15px;
  font-size: 14px;
`

export const LinkDefault = ButtonDefault.withComponent(Link);
export const LinkInfo = ButtonInfo.withComponent(Link);
export const LinkSmall = SmallButton.withComponent(Link);



// WEBPACK FOOTER //
// ./src/components/buttons/index.js